<template>
  <div class="short-video-item">
    <div class="video-container" @click="togglePlay">
      <video
        ref="videoRef"
        :src="videoUrl"
        :poster="coverUrl"
        playsinline
        webkit-playsinline
        preload="auto"
        :autoplay="active"
        @play="onPlay"
        @pause="onPause"
        @ended="onEnded"
        class="video-player"
      ></video>
      <img v-if="!isPlaying && !active" :src="coverUrl" class="cover-img" />
      <!-- 播放指引图标：仅在未播放或暂停时显示，居中覆盖在视频上方 -->
      <div
        v-if="!isPlaying"
        class="play-icon"
        aria-label="播放视频"
      >
        <!-- SVG播放按钮，可替换为图片或iconfont -->
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="32" fill="rgba(0,0,0,0.45)"/>
          <polygon points="26,20 48,32 26,44" fill="#fff"/>
        </svg>
      </div>
    </div>
    <div class="info">
      <div class="title">{{ title }}</div>
      <div class="desc">{{ desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShortVideoItem',
  props: {
    title: String,
    desc: String,
    videoUrl: String,
    coverUrl: String,
    active: Boolean
  },
  data () {
    return {
      isPlaying: false
    }
  },
  watch: {
    active (val) {
      if (val) {
        this.$refs.videoRef && this.$refs.videoRef.play()
      } else {
        this.$refs.videoRef && this.$refs.videoRef.pause()
      }
    }
  },
  methods: {
    onPlay () {
      this.isPlaying = true
    },
    onPause () {
      this.isPlaying = false
    },
    onEnded () {
      this.$emit('videoEnded')
    },
    togglePlay () {
      if (!this.isPlaying) {
        this.$refs.videoRef && this.$refs.videoRef.play()
      } else {
        this.$refs.videoRef && this.$refs.videoRef.pause()
      }
    }
  }
}
</script>

<style scoped>
.short-video-item {
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background: #000;
}
.video-container {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-player {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  background: #000;
}
.cover-img {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.info {
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100vw;
  color: #fff;
  z-index: 3;
  padding: 0 20px;
  text-shadow: 0 2px 8px rgba(0,0,0,0.5);
  max-width: 100vw;
  box-sizing: border-box;
  overflow-wrap: break-word;
}
.title {
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 10px;
  color: #fff;
  text-shadow: 0 4px 16px rgba(0,0,0,0.25), 0 2px 8px rgba(0,0,0,0.5);
  text-align: justify;
  border-left: 4px solid #ff8a00;
  padding-left: 10px;
  border-radius: 2px;
  word-break: break-all;
  white-space: pre-line;
  max-width: 100%;
  box-sizing: border-box;
  overflow-wrap: break-word;
  text-decoration: none !important;
}
.desc {
  font-size: 16px;
  padding: 4px;
  text-align: justify;
  border-radius: 4px;
  word-break: break-all;
  white-space: pre-line;
  max-width: 100%;
  box-sizing: border-box;
  overflow-wrap: break-word;
  text-shadow: 0 4px 16px rgba(0,0,0,0.25), 0 2px 8px rgba(0,0,0,0.5);
  background-color: #0000003b;
}
.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  cursor: pointer;
  /* 适当增加点击区域 */
  pointer-events: none; /* 避免遮挡点击事件，点击事件仍由video-container处理 */
}
</style>
